import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    tableId: String,
  };

  connect() {}

  toggleAllInterests(event) {
    const checked = event.target.checked;
    const checkboxes = document.querySelectorAll(".interest-checkbox");

    checkboxes.forEach((checkbox) => {
      checkbox.checked = checked;
    });
  }

  updateRow(event) {
    const [_data, _status, xhr] = event.detail;

    const tempDiv = document.createElement("table");
    tempDiv.innerHTML = xhr.response;
    const tempRow = tempDiv.querySelector("tr");

    if (!tempRow || !tempRow.id) {
      console.warn(
        "No <tr> with valid ID found in response; cannot update row"
      );
      return;
    }
    this.cleanUpModal();

    const targetRow = document.getElementById(tempRow.id);
    if (!targetRow) {
      console.error(`Row with ID ${tempRow.id} not found in table`);
      return;
    }

    targetRow.innerHTML = tempRow.innerHTML;

    try {
      if ($.fn.DataTable.isDataTable("#leadsTable")) {
        $("#leadsTable").DataTable().destroy();
      }

      $("#leadsTable").DataTable({
        paging: true,
        pageLength: 100,
        lengthMenu: [
          [10, 25, 50, 100],
          [10, 25, 50, 100],
        ],
        searching: true,
        ordering: true,
        info: true,
        stateSave: true,
        order: [[14, "desc"]],
      });
    } catch (error) {
      console.error("Error reinitializing DataTable:", error);
    }

    this.reinstantiateTooltips();
  }

  openModal(event) {
    const [_data, _status, xhr] = event.detail;
    const form = document.createElement("div");
    form.innerHTML = xhr.response;

    this.cleanUpModal();

    var editModal = bootstrap.Modal.getOrCreateInstance(
      form.querySelector("#editModal")
    );
    editModal.show();
  }

  openNewModal(event) {
    const [_data, _status, xhr] = event.detail;
    const form = document.createElement("div");
    form.innerHTML = xhr.response;

    this.cleanUpModal();
    var newModal = bootstrap.Modal.getOrCreateInstance(
      form.querySelector("#newModal")
    );
    newModal.show();
  }

  appendRow(event) {
    const [_data, _status, xhr] = event.detail;
    const responseHtml = xhr.response;

    const tempTable = document.createElement("table");
    tempTable.innerHTML = responseHtml;
    const tempRow = tempTable.querySelector("tr");

    const targetTable = document.getElementById(this.tableIdValue);
    const targetTableBody = targetTable.querySelector("tbody");

    if (!tempRow || !targetTableBody) {
      console.error("Row or table body not found");
      return;
    }

    this.cleanUpModal();

    try {
      if ($.fn.DataTable.isDataTable("#leadsTable")) {
        $("#leadsTable").DataTable().destroy();
      }

      targetTableBody.insertBefore(tempRow, targetTableBody.firstElementChild);

      $("#leadsTable").DataTable({
        paging: true,
        pageLength: 100,
        lengthMenu: [
          [10, 25, 50, 100],
          [10, 25, 50, 100],
        ],
        searching: true,
        ordering: true,
        info: true,
        stateSave: true,
        order: [[14, "desc"]],
      });
    } catch (error) {
      console.error("Error in DataTable operations:", error);
      targetTableBody.insertBefore(tempRow, targetTableBody.firstElementChild);
    }

    this.reinstantiateTooltips();
  }

  cleanUpModal() {
    const existingModal = document.querySelector("#editModal");
    if (existingModal) {
      const modalInstance = bootstrap.Modal.getInstance(existingModal);
      if (modalInstance) {
        modalInstance.dispose();
      }
      existingModal.remove();
    }

    const newModal = document.querySelector("#newModal");
    if (newModal) {
      const modalInstance = bootstrap.Modal.getInstance(newModal);
      if (modalInstance) {
        modalInstance.dispose();
      }
      newModal.remove();
    }
  }

  reinstantiateTooltips() {
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      var tooltip = new bootstrap.Tooltip(tooltipTriggerEl);
      tooltipTriggerEl.addEventListener("click", function () {
        tooltip.hide();
      });
    });
  }
}
